import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { getAssetLink } from '@/helpers/get-asset-link'

const getImageUrl = (image: File | string | { url: string } | null | undefined) => {
  if (!image) return null
  if (typeof image === 'object' && 'url' in image) return image.url
  if (image instanceof File) return URL.createObjectURL(image)
  try {
    return new URL(image)
  } catch {
    return getAssetLink({
      fallback: { file: 'training_image.png' },
      file: image,
      path: 'chitown-images/training',
    })
  }
}

interface ImageSectionProps {
  image: File
  eventType: string
}

export const ImageSection = ({ image, eventType }: ImageSectionProps) => {
  const { t } = useTranslation(['eventManagement'])
  const imageUrl = useMemo(() => getImageUrl(image), [image])

  return (
    <div
      className="mobile-preview__image"
      style={{ backgroundImage: imageUrl ? `url("${imageUrl}")` : '' }}
    >
      {imageUrl ? '' : t('eventManagement:common.eventTypePhoto', { eventType })}
    </div>
  )
}
